import { Component, EventEmitter, Input, NgZone, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MinorService } from 'src/app/services/minor/minor.service';
import { TutorService } from 'src/app/services/tutor/tutor.service';
import { codeCountry } from 'src/app/types/lists-type';
import { countryISO } from 'src/app/utility/lists/lists';
export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
  label: string;
  type: string;
  value: string;
  name: string;
  options?: Opt[],
  min?:number,
  max?:number,
  required:boolean,
  disabled:boolean
}
export interface Opt {
  value: string;
  viewValue: string;
}

export interface Status{
  active?: boolean;
  pending?: boolean;
  email?: any
}
@Component({
  selector: 'app-minors-profile',
  templateUrl: './minors-profile.component.html',
  styleUrls: ['./minors-profile.component.scss']
})

export class MinorsProfileComponent {
  @Input() tutorUID: string = "";
  @Input() lang: string = "";
  @Input() minors: any = {};
  @Input() listMinors: any = [];
  @Output() deleteMinor = new EventEmitter();
  @Input() respMinors = new BehaviorSubject([]);
  months: string[] = ["option.january", "option.february", "option.march", "option.april", "option.may",
  "option.june", "option.july", "option.august", "option.september", "option.october", "option.november", "option.december"];
  list: any =[];
  status: Status={};
  country: any=[];

  tilesProfile: Tile[] = [
  ];
  constructor(private tutorService: TutorService,private minorService: MinorService, public ngZone: NgZone){
    this.country = Object.keys(countryISO).map(el=> {return {value:el, viewValue: countryISO[el as codeCountry]}});
    this.minorService.toBeDeleted.subscribe((act:any)=>{
      this.listMinors.find((mn:any)=>{
        if(mn.UID === act.uid){
          if(act.deleted){
            mn.data.status_info = "tobedeleted";
          }else{
            mn.isActive = false;
            mn.data.status_info = "disabled";
          }
            
        }
      });
    });

    this.tutorService.changeStatus$.subscribe((status: Status)=>{
     if(status.email.value){
      let counterNotify: number = 0;
      let objList = {email:status.email.value, pending:status.pending, active:status.active};
      if(this.list.length>0 && this.list.find((ob:any)=>ob.email == status.email.value)){
      this.list[this.list.findIndex((ob:any)=>ob.email == status.email.value)] = objList;
      }else{
        this.list.push(objList)
      }
      for (const st of this.list) {
        if(!st.active){
          counterNotify++;
        }
      } 
      this.tutorService.minorsStatus.next({counter:counterNotify, emailList:this.list,email:status.email.value});
      this.listMinors.forEach((min:any)=> {
        if(min.profile.email == status.email.value)
          min.status= status;
      });
     }
    });
  }
  setValues(profile:any, data:any = {}){
    let minTile:Tile[] = [];
    this.tilesProfile.forEach(tl => {
      if(profile[tl.name.split(".")[1]])
        tl.value= profile[tl.name.split(".")[1]];
      else if(data?.[tl.name.split(".")[1]])
        tl.value= data[tl.name.split(".")[1]];
      minTile.push(tl);
    });
    this.initTile();
    return minTile;
  }
  initTile(){
   this.tilesProfile= [
      { text: '', cols: 4, rows: 1, color: '#FFFFFF', disabled:false, required:true, name: "profile.email", value: "", label: "field.label.email", type: "email" },
      { text: '', cols: 2, rows: 1, color: '#FFFFFF', disabled:false, required:true, name: "profile.firstName", value: "", label: "field.label.firstname", type: "text" },
      { text: '', cols: 2, rows: 1, color: '#FFFFFF', disabled:false, required:true, name: "profile.lastName", value: "", label: "field.label.lastname", type: "text" },
      { text: '', cols: 2, rows: 1, color: '#FFFFFF', disabled:true,  required:true, name: "profile.birthMonth", value: "", label: "field.label.birthmonth", type: "select", options: this.getMonths() },
      { text: '', cols: 2, rows: 1, color: '#FFFFFF', disabled:true,  required:true, name: "profile.birthYear", value: "", label: "field.label.birthyear", type: "number", min:1900, max:new Date().getFullYear() },
      { text: '', cols: 2, rows: 1, color: '#FFFFFF', disabled:false, required:false, name:"profile.gender", value: "", label: "field.label.gender", type: "select", options: [{ value: "m", viewValue: "option.male" }, { value: "f", viewValue: "option.female" },{ value: "", viewValue: "" }] },
      { text: '', cols: 2, rows: 1, color: '#FFFFFF', disabled:true,  required:true, name: "profile.country", value: "", label: "field.label.country", type: "select", options: this.country },
      { text: '', cols: 2, rows: 1, color: '#FFFFFF', disabled:false, required:true, name: "data.tutorFirstName", value: "", label: "label.tutorName", type: "text" },
      { text: '', cols: 2, rows: 1, color: '#FFFFFF', disabled:false, required:true, name: "data.tutorLastName", value: "", label: "label.tutorLastName", type: "text" },
    ];
  }

  getMonths() {
    return this.months.map((month, index) => ({ value: index + 1, viewValue: month }));
  }

  initListMinorsStatus(){
    this.listMinors.forEach((min:any)=> {
      min.status= min.status || {
        active: false,
        pending: false,
      };
      min.tilesProfile = this.setValues(min.profile,min.data);
    });
  }
  ngOnInit(){
    this.respMinors.subscribe((resp:any)=>{
      this.ngZone.run(()=>{
        if(resp.length >0){
          this.listMinors = resp.map((el:any)=>{
            if(el.data){
              el.data.isMinor = typeof el.data.isMinor === 'string'?el.data.isMinor == "true" :el.data.isMinor;
              el.data.isMinorPlus = typeof el.data.isMinorPlus === 'string'?el.data.isMinorPlus == "true" :el.data.isMinorPlus;
            }
            return el;
          });
          this.initTile();
          this.initListMinorsStatus();
        }
      });
    });
   
  }
  deleteMin(minOrplus:object){
    this.deleteMinor.emit(minOrplus);
  }
  updateMinor(minorUpdated:any){
    if(minorUpdated.data){
      minorUpdated.data.isMinor = typeof minorUpdated.data.isMinor === 'string'?minorUpdated.data.isMinor == "true" :minorUpdated.data.isMinor;
      minorUpdated.data.isMinorPlus = typeof minorUpdated.data.isMinorPlus === 'string'?minorUpdated.data.isMinorPlus == "true" :minorUpdated.data.isMinorPlus;
    }
    this.listMinors=this.listMinors.map((mn:any)=> mn.UID === minorUpdated.UID? {...mn,...minorUpdated}:mn);
    this.initListMinorsStatus();
  }
}
